export interface DialogFontConfig {
  family: string;
  nameSize: number;
  dialogSize: number;
  choiceSize: number;
  continueSize: number;
  closeSize: number;
  resolution: number;
}

export interface DialogColorConfig {
  name: number;
  dialog: number;
  choice: number;
  continue: number;
  close: number;
  background: number;
  border: number;
  innerBorder: number;
  shadow: number;
  hover: number;
  white: number;
  redHover: number;
}

export interface DialogBoxConfig {
  widthRatio: number;
  heightDefault: number;
  heightWithChoices: number;
  margin: number;
  borderRadius: number;
  shadowOffset: number;
  shadowRadius: number;
}

export interface DialogAnimationConfig {
  pulseSpeed: number;
  pulseMin: number;
  pulseRange: number;
}

export interface DialogTextConfig {
  continue: string;
  continueChoice: string;
  continueEnd: string;
}

export interface DialogConfig {
  font: DialogFontConfig;
  colors: DialogColorConfig;
  box: DialogBoxConfig;
  animation: DialogAnimationConfig;
  text: DialogTextConfig;
}

export const dialogConfig: DialogConfig = {
  font: {
    family: 'serif', // More atmospheric serif font
    nameSize: 22,
    dialogSize: 17,
    choiceSize: 14,
    continueSize: 16,
    closeSize: 16,
    resolution: 2,
  },
  colors: {
    name: 0xd4af37, // Dark gold for speaker names
    dialog: 0xe6ddd4, // Warm off-white/parchment color
    choice: 0xd0c5ba, // Slightly darker parchment for choices
    continue: 0x8b7355, // Muted brown for continue text
    close: 0x8b7355,
    background: 0x2c1810, // Very dark brown/black background
    border: 0x5d4037, // Dark brown border
    innerBorder: 0x795548, // Slightly lighter brown inner border
    shadow: 0x000000, // Pure black shadows
    hover: 0xffa726, // Warm orange/amber hover
    white: 0xe6ddd4, // Same as dialog text
    redHover: 0xd32f2f, // Dark red for danger/negative actions
  },
  box: {
    widthRatio: 0.8,
    heightDefault: 220,
    heightWithChoices: 280,
    margin: 20,
    borderRadius: 8, // Slightly sharper corners for more serious feel
    shadowOffset: 4, // Larger shadow for more dramatic effect
    shadowRadius: 16, // Bigger shadow blur
  },
  animation: {
    pulseSpeed: 0.003, // Slower, more ominous pulse
    pulseMin: 0.7,
    pulseRange: 0.3, // More dramatic pulse range
  },
  text: {
    continue: 'Next ▶',
    continueChoice: '▶Choose',
    continueEnd: '✕',
  },
} as const;
